module.exports = __webpack_public_path__ + "img/oah-role-provider.6be2e3b5.svg";